module.exports = __webpack_public_path__ + "static/media/text-size.89d3e168.svg";